// extracted by mini-css-extract-plugin
module.exports = {"textWrapper":"ReadMore_textWrapper__1htae","ellipsisButton":"ReadMore_ellipsisButton__9NhDv","ellipsisButtonOpened":"ReadMore_ellipsisButtonOpened__2G6PG"};